import React, {memo, useState} from 'react';

import {Row, Col, Table, Form, Pagination} from "react-bootstrap";
import Loader from "../Loader";
import TicketDetailModal from "./TicketDetailModal";

const DetailedReport = ({data, pagination, isLoading, ticketNumber, onTicketSearch, onPageChange}) => {
    const [selectedNumber, setSelectedNumber] = useState(null);

    const page = pagination ? pagination.page : 1;
    const numPages = pagination ? pagination.num_pages : 1;
    const count = pagination ? pagination.count : (data ? data.length : 0);

    const goTo = (p) => {
        if (p >= 1 && p <= numPages && p !== page) {
            onPageChange(p);
        }
    };

    return (
        <Row>
        <Col>
            <Form.Control
                type="text"
                placeholder="Пошук за номером квитку (12 цифр)"
                value={ticketNumber}
                onChange={e => onTicketSearch(e.target.value)}
                style={{marginTop: '16px', maxWidth: '320px'}}
            />

            {isLoading ? <Loader /> : (
                <>
                    <Table striped bordered hover size="sm" style={{marginTop: '16px'}}>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Тип квитку</th>
                            <th>Створено</th>
                            <th>Вартість</th>
                            <th>Тип оплати</th>
                            <th>Касир</th>
                            <th style={{width: '12%'}}>Відвідувач</th>
                            <th style={{width: '12%'}}>Пільга</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data && data.map(t => (
                            <tr key={t.number}>
                                <td>
                                    <a
                                        href="#"
                                        onClick={e => {e.preventDefault(); setSelectedNumber(t.number);}}
                                    ><b>{t.number}</b></a>
                                </td>
                                <td>{t.service}</td>
                                <td>{t.created_at}</td>
                                <td>{t.cost}</td>
                                <td>{t.payment_type}</td>
                                <td>{t.cashier}</td>
                                <td style={{width: '12%'}}>{t.visitor}</td>
                                <td style={{width: '12%'}}>{t.exemption}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>

                    {(!data || data.length === 0) && <p>Квитків не знайдено.</p>}

                    {numPages > 1 && (
                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '24px'}}>
                            <Pagination style={{marginBottom: 0}}>
                                <Pagination.First disabled={page <= 1} onClick={() => goTo(1)} />
                                <Pagination.Prev disabled={page <= 1} onClick={() => goTo(page - 1)} />
                                <Pagination.Item active>{page}</Pagination.Item>
                                <Pagination.Next disabled={page >= numPages} onClick={() => goTo(page + 1)} />
                                <Pagination.Last disabled={page >= numPages} onClick={() => goTo(numPages)} />
                            </Pagination>
                            <span>Сторінка {page} з {numPages} ({count} квитків)</span>
                        </div>
                    )}
                </>
            )}

            <TicketDetailModal
                number={selectedNumber}
                show={selectedNumber !== null}
                onHide={() => setSelectedNumber(null)}
            />
        </Col>
    </Row>
    )
};

export default memo(DetailedReport);
